import Vue from 'vue'
import waitAll from './utils/src/waitAll'
import WildEmitter from './utils/src/WildEmitter'
//import fontSize from './utils/src/font'
//import message from './utils/src/resetMessage'
import { getDicts } from "@/api/system/dict/data";
// 字典数据组件
import DictData from '@/components/DictData'
import DictData2 from '@/components/DictData2'
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree, fontSize } from "@/utils/ruoyi";


import vueAwesomeSwiper from 'vue-awesome-swiper'  //引入滑动插件
import 'swiper/swiper-bundle.css'  //引入样式
Vue.use(vueAwesomeSwiper)  //使用插件
//Vue.prototype.$message = message; //重写message提示框
// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.fontSize = fontSize
DictData.install()
DictData2.install()

let global = window || {};

function ZJApp() {
    WildEmitter.call(this);
}
WildEmitter.mixin(ZJApp);

global.ZJApp = global.ZJApp || new ZJApp();


waitAll([

    // 加载 element-ui 样式
    () => import(/* webpackChunkName: 'theme-default-element-ui' */ './theme-default/element.scss'),

    // 加载 app 样式
    () => import(/* webpackChunkName: 'theme-default-app' */ './theme-default/index.scss'),

    // 加载样式定义文件
    () => import(/* webpackChunkName: 'theme' */ './theme-default/index'),

    () => import(/* webpackChunkName: 'client' */ './index'),
])
    .then(r => {
        let bootstrap = r[3].default.bootstrap;
        let config = {};
        let theme = r[2].default;
        bootstrap({
            el: '#app',
            config,
            theme,
        });
    });


